export default function DialogBox({
  title = "ALERT",
  message = "",
  confirmLabel = "OK",
  cancelLabel = "CANCEL",
  onConfirm,
  onCancel,
}) {
  return (
    <div className="motif-dialog">
      <div className="bar sun">
        <span className="box"></span>
        <span className="title">{title}</span>
        <span className="box" style={{ visibility: "hidden" }}></span>
      </div>
      <div className="motif-dialog-body">
        <div className="motif-dialog-icon">
          <svg viewBox="0 0 20 20" fill="var(--sun)" stroke="var(--ink)" strokeWidth="1.5">
            <polygon points="10,2 18,18 2,18" />
          </svg>
        </div>
        <div className="motif-dialog-msg">{message}</div>
        <div className="motif-dialog-buttons">
          <button
            className="motif-dialog-btn primary"
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
          <button
            className="motif-dialog-btn"
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
